module.exports = __webpack_public_path__ + "img/Usps.83b53f82.png";